import { render } from "./process-edit.vue?vue&type=template&id=4a2d8d32&scoped=true&ts=true"
import script from "./process-edit.vue?vue&type=script&lang=ts"
export * from "./process-edit.vue?vue&type=script&lang=ts"

import "./process-edit.vue?vue&type=style&index=0&id=4a2d8d32&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2d8d32"]])

export default __exports__